module.exports = __webpack_public_path__ + "static/media/microsoft.71dabd96.svg";